import React from "react";

import * as StateLib from "@/Utils/StateLib";
import TableResultsModal from "@/appComponents/Blocks/Modals/TableResultsModal/TableResultsModal";
import { useReportingContext } from "@/providers/ReportsProvider";
import { kDefaultDirFields } from "@coreapp/constants";

const ReportModal = () => {
  const { reportSearchState, tableHandleRef } = useReportingContext();
  const [data, setData] = React.useState([]);
  const [startPage, setStartPage] = React.useState(1);

  let wsMgr = StateLib.GetWSMgr();

  React.useEffect(() => {
    let results = reportSearchState ? reportSearchState.results : [];
    setData(results);
    setStartPage(1);
  }, [reportSearchState]);

  if (!wsMgr) return;

  return (
    <TableResultsModal
      tableData={data}
      tableHandleRef={tableHandleRef}
      tableColumnNames={reportSearchState?.columnNames ?? kDefaultDirFields}
      startPage={startPage}
    />
  );
};

export default ReportModal;
